/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';
import { itemDependencySchema } from './itemDependencySchema';

export const scenarioItemSchema = z.object({
  createdAt: z.iso.datetime(),
  createdBy: z.string(),
  deadlineDateTime: z.iso.datetime().nullish(),
  deletedInItemStore: z.boolean(),
  get dependencies() {
    return z.array(itemDependencySchema).nullish();
  },
  earliestStartDateTime: z.iso.datetime().nullish(),
  estimationId: z.int().nullish(),
  externalKey: z.string().nullish(),
  imputedFields: z.array(z.enum(['ESTIMATION', 'TEAM'])).nullish(),
  itemId: z.int(),
  itemStatusId: z.int(),
  itemTypeId: z.int(),
  mlimputed: z.boolean(),
  name: z.string(),
  organizationId: z.string(),
  outOfScopeReason: z.enum(['SCOPE_FLEXIBILITY', 'PRIORITY_DRIFT']).nullish(),
  parentId: z.int().nullish(),
  priority: z.string(),
  resourceIds: z.array(z.int()).nullish(),
  scenarioId: z.int(),
  schedulingValidations: z
    .array(
      z.enum([
        'MISSING_TEAM',
        'EMPTY_TEAM',
        'NO_AVAILABILITY',
        'TEAM_UNAVAILABLE',
        'MISSING_ESTIMATION',
        'INVALID_TARGET_DATES',
        'ITEM_IS_DONE',
        'PARENT_UNSCHEDULABLE',
        'DEPENDENCY_UNSCHEDULABLE',
        'CIRCULAR_DEPENDENCY',
        'OUTSIDE_CALENDAR_LIMITS',
      ]),
    )
    .nullish(),
  teamId: z.int().nullish(),
  timeSpentSeconds: z.int().nullish(),
  updatedAt: z.iso.datetime(),
  updatedBy: z.string(),
  userUpdatedAt: z.iso.datetime().nullish(),
});
